import JSZip from 'jszip';

import type { PackageJson } from '../types';

/**
 * Convert File to base64 string (without data URL prefix)
 * @param file - File object to convert
 * @returns Promise resolving to base64 string
 */
export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const result = reader.result as string;
            // Remove "data:application/zip;base64," prefix
            const base64 = result.split(',')[1];
            resolve(base64);
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

/**
 * Extract package.json from zip file
 * @param zipInstance - JSZip instance
 * @returns Promise resolving to parsed package.json or null
 */
export const extractPackageJson = async (zipInstance: JSZip): Promise<PackageJson | null> => {
    const file = zipInstance.file('package.json');
    if (!file || file.dir) return null;

    try {
        const content = await file.async('string');
        return JSON.parse(content) as PackageJson;
    } catch (error) {
        console.warn('Failed to parse package.json:', error);
        return null;
    }
};

/**
 * Get version from package.json (default: "0.0.0")
 * @param packageJson - Parsed package.json
 * @returns Version string
 */
export const extractVersion = (packageJson: PackageJson | null): string => {
    return packageJson?.version || '0.0.0';
};
